"use strict";
import "@webhare-system/wh/integration"; //we're a WebHare site
import "@webhare-publisher/richcontent/all";
import * as dompack from "dompack";

require('../css/main.css');

document.addEventListener("DOMContentLoaded", function()
{

}); //DOMContentLoaded

